import { Api } from './api';

export class AssetsApi {
    private static readonly PATH = '/assets';

    constructor(private readonly m_api: Api) {}

    public async getAssets() {
        return this.m_api.get(AssetsApi.PATH);
    }
}
